import * as React from 'react';
import NativeAdUserFlight from 'mini-mail-nativead-userchecker/lib/NativeAdUserFlight';
import { getNativeAdShowStatus } from 'mini-mail-nativead-userchecker/lib/getNativeAdShowStatus';
import { observer } from 'mobx-react';

const styles = require('./nativeAdItemPreLoading.scss');
@observer
export default class NativeAdPreloadingStubElement extends React.Component<{}, {}> {
    render() {
        const nativeAdShowStatus = getNativeAdShowStatus();
        return nativeAdShowStatus === NativeAdUserFlight.PrebidMobileBannerAd ? (
            <div className={styles.nativeBannerAdPreLoadStaticContainerExp}>
                {/* Dummy placeholder for the banner ad experience */}
                <div className={styles.nativeBannerAdPreLoadStaticContainerExpInnerPlaceholder} />
            </div>
        ) : (
            <div className={styles.nativeAdPreLoadStaticContainerExp} />
        );
    }
}
